/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResumeDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function ResumeDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started/Pause/Details/ResumeDate",
  onChange,
  isInvalid
  
}) {
let selectedResumeDateValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'resume_date',
format: fromFormat.dateShortIn,
})
let selectedResumeDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'resume_date',
validate: fromValidate.dateFuture,
required: true,
})
let selectedResumeDateChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'resume_date',
formatOut: fromFormat.dateShortOutTempFixForMaskedInput,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="date"
 maxWidth={110}
 marginRight={dtSpaceXs}
 data="selected.resume_date"
 format="/Data/format.js dateShortIn"
 formatOut="/Data/format.js dateShortOutTempFixForMaskedInput"
 validate="/Data/validate.js dateFuture"
 required={true}
 onChange={selectedResumeDateChangeData}
 value={selectedResumeDateValueData}
 invalid={!selectedResumeDateIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Automatically resume on"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 disablePast={true}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}